@if (tabs.length > 1 && number$ | async) {
    <div class="grid-page mx-sm-4 mt-3">
        <dx-tabs
            keyExpr="key"
            [items]="tabs"
            [selectedItemKeys]="[selectedTab]"
            [iconPosition]="'start'"
            (onItemClick)="selectedTab = $event.itemData.key"
            [scrollByContent]="true"
            [scrollingEnabled]="true"
            [showNavButtons]="false"></dx-tabs>
    </div>
} 

@if (selectedTab === 'details' && showDetails) {
    <app-empty-check-in-details [number]="number$ | async"></app-empty-check-in-details>
} @else if (selectedTab === 'history' && showHistory) {
    <app-empty-check-in-history [number]="number$ | async"></app-empty-check-in-history>
}